export function initModalIframe() {
    let modal = null;

    function createModal() {
        if (modal) return modal;

        modal = document.createElement('div');
        modal.className = 'modal-iframe';
        modal.innerHTML = `
            <div class="modal-iframe__overlay"></div>
            <div class="modal-iframe__container">
                <div class="modal-iframe__header">
                    <h3 class="modal-iframe__title"></h3>
                    <button class="modal-iframe__close" type="button" aria-label="Close modal">&times;</button>
                </div>
                <div class="modal-iframe__content">
                    <iframe class="modal-iframe__iframe auto-resize" width="100%" height="100%" frameborder="0" loading="lazy"></iframe>
                </div>
            </div>
        `;

        document.body.appendChild(modal);

        const overlay = modal.querySelector('.modal-iframe__overlay');
        const closeBtn = modal.querySelector('.modal-iframe__close');
        const iframe = modal.querySelector('.modal-iframe__iframe');

        function closeModal() {
            modal.classList.remove('modal-iframe--active');
            document.body.classList.remove('modal-iframe-open');
            iframe.src = '';
            
            setTimeout(() => {
                modal.style.display = 'none';
            }, 300);
        }

        function openModal(src, title = 'Student Portal') {
            iframe.src = src;
            const titleElement = modal.querySelector('.modal-iframe__title');
            titleElement.textContent = title;
            
            // Add data attribute for Certificate Verification styling
            if (title === 'Certificate Verification') {
                titleElement.setAttribute('data-title', 'Certificate Verification');
            } else {
                titleElement.removeAttribute('data-title');
            }
            
            modal.style.display = 'block';
            document.body.classList.add('modal-iframe-open');
            
            setTimeout(() => {
                modal.classList.add('modal-iframe--active');
            }, 10);
        }

        overlay.addEventListener('click', closeModal);
        closeBtn.addEventListener('click', closeModal);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('modal-iframe--active')) {
                closeModal();
            }
        });

        modal.openModal = openModal;
        modal.closeModal = closeModal;

        return modal;
    }

    function initTriggers() {
        document.addEventListener('click', (e) => {
            // Check for certificate verification class first
            let trigger = e.target.closest('.certificate-verification');
            let isCertificateVerification = false;
            
            if (trigger) {
                isCertificateVerification = true;
            } else {
                // Check for existing modal iframe trigger class
                trigger = e.target.closest('.modal-iframe-trigger');
            }

            if (!trigger) return;

            e.preventDefault();

            let src, title;
            
            // Handle Certificate Verification specific logic
            if (isCertificateVerification) {
                src = 'https://portal.ivetinstitute.com.au/student/certificates';
                title = 'Certificate Verification';
            } else {
                src = trigger.dataset.modalIframe || trigger.href;
                title = trigger.dataset.modalTitle || 'Student Portal';
            }

            if (!src) {
                console.warn('Modal iframe trigger missing src');
                return;
            }

            const modalElement = createModal();
            modalElement.openModal(src, title);
        });
    }

    initTriggers();
}